import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

type QueryPatch = Record<string, string | number | undefined | null>;

// Keeps list filters and paging in the URL so they survive opening an order
// and coming back, and can be linked to from other pages.
const useQueryState = () => {
  const location = useLocation();
  const history = useHistory();
  const params = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );

  const update = useCallback(
    (patch: QueryPatch) => {
      const next = new URLSearchParams(location.search);
      Object.entries(patch).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') {
          next.delete(key);
        } else {
          next.set(key, String(value));
        }
      });
      const search = next.toString();
      history.replace({
        pathname: location.pathname,
        search: search ? `?${search}` : '',
      });
    },
    [history, location.pathname, location.search],
  );

  return [params, update] as const;
};

export default useQueryState;
